<template>
  <div class="wrapper wrapper-content p-0 animated fadeInUp">
    <div class="ibox-body">
      <!-- Header with add icon -->
      <div class="ibox-title style_2 d-flex justify-content-between">
        <h5>{{ $t("navigations.activity list") }}</h5>
         <div class="position-relative align-self-center">
        <img src="@/assets/img/create.png" width="17" alt="Add Activity" style="cursor: pointer;"
          @click="addNewRow" />
        <div class="tool-tip mt-2">Add Activity</div>
      </div>
      </div>
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Activity ID <sup><i class="fa fa-asterisk required"></i></sup></th>
                <th>Activity Name <sup><i class="fa fa-asterisk required"></i></sup></th>
                <th>Activity Type</th>
                <th>Description</th>
                <th>Notes</th>
                <th>Required Form</th>
                <th>Form Required?</th>
                <th class="text-center sticky-column">Edit</th>
                <th class="text-center">Delete</th>
              </tr>
            </thead>
            <tbody>
              <!-- New Row for creation -->
              <tr v-if="isAddingNew">
                <td>
                  <input v-model="newRow.activityId" class="form-control" type="text" @input="clearNewFieldError('activityId')" />
                  <div v-if="newRowErrors.activityId" class="text-danger">{{ newRowErrors.activityId }}</div>
                </td>
                <td>
                  <input v-model="newRow.activityName" class="form-control" type="text" @input="clearNewFieldError('activityName')" />
                  <div v-if="newRowErrors.activityName" class="text-danger">{{ newRowErrors.activityName }}</div>
                </td>
                <td>
                  <input v-model="newRow.activityType" class="form-control" type="text" />
                </td>
                <td>
                  <textarea v-model="newRow.description" class="form-control" rows="3"></textarea>
                </td>
                <td>
                  <textarea v-model="newRow.notes" class="form-control" rows="3"></textarea>
                </td>
                <td>
                  <input v-model="newRow.requiredForm" class="form-control" type="text" />
                </td>
                <td>
                  <select class="form-select" v-model="newRow.formRequired">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </td>
                <td class="text-center sticky-column">
                  <i class="fa fa-check action-icon text-success" @click="saveNewRow" title="Save"></i>
                  <i class="fa fa-times action-icon text-danger" @click="cancelNewRow" title="Cancel"></i>
                </td>
                <td></td>
              </tr>

              <!-- No data row -->
              <tr v-if="!isAddingNew && activities.length === 0">
                <td colspan="9" class="text-center">No data available.</td>
              </tr>

              <!-- Existing rows -->
              <tr v-for="(activity, index) in activities" :key="activity.id">
                <!-- Activity ID -->
                <td v-if="editIndex !== index">{{ activity.activityId }}</td>
                <td v-else>
                  <input v-model="editableRow.activityId" class="form-control" type="text" @input="clearFieldError('activityId')" />
                  <div v-if="validationErrors.activityId" class="text-danger">{{ validationErrors.activityId }}</div>
                </td>
                <!-- Activity Name -->
                <td v-if="editIndex !== index">{{ activity.activityName }}</td>
                <td v-else>
                  <input v-model="editableRow.activityName" class="form-control" type="text" @input="clearFieldError('activityName')" />
                  <div v-if="validationErrors.activityName" class="text-danger">{{ validationErrors.activityName }}</div>
                </td>
                <!-- Activity Type -->
                <td v-if="editIndex !== index">{{ activity.activityType }}</td>
                <td v-else>
                  <input v-model="editableRow.activityType" class="form-control" type="text" />
                </td>
                <!-- Description -->
                <!-- NEW: more/less toggle when the description text is longer than descriptionCharLimit -->
                <td v-if="editIndex !== index">
                  <div class="wrap-text">
                    {{ isDescriptionExpanded(activity.id) ? activity.description : truncatedText(activity.description) }}
                    <a
                      v-if="activity.description && activity.description.length > descriptionCharLimit"
                      href="javascript:void(0)"
                      class="more-less-link"
                      @click="toggleDescription(activity.id)"
                    >
                      {{ isDescriptionExpanded(activity.id) ? "Less" : "More" }}
                    </a>
                  </div>
                </td>
                <td v-else>
                  <textarea v-model="editableRow.description" class="form-control" rows="3"></textarea>
                </td>
                <!-- Notes -->
                <td v-if="editIndex !== index">
                  <div class="wrap-text">{{ activity.notes }}</div>
                </td>
                <td v-else>
                  <textarea v-model="editableRow.notes" class="form-control" rows="3"></textarea>
                </td>
                <!-- Required Form -->
                <td v-if="editIndex !== index">{{ activity.requiredForm }}</td>
                <td v-else>
                  <input v-model="editableRow.requiredForm" class="form-control" type="text" />
                </td>
                <!-- Form Required? -->
                <td v-if="editIndex !== index">{{ activity.formRequired ? "Yes" : "No" }}</td>
                <td v-else>
                  <select class="form-select" v-model="editableRow.formRequired">
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </td>
                <!-- Edit Actions -->
                <td class="text-center sticky-column">
                  <template v-if="editIndex !== index">
                    <i class="fa fa-edit edit-delete" v-if="protocol.status !== 'Generated'"
                      @click.prevent="editRow(index, activity)"></i>
                  </template>
                  <template v-else>
                    <i class="fa fa-check action-icon text-success" @click="updateRow(activity.id)" title="Update"></i>
                    <i class="fa fa-times action-icon text-danger" @click="cancelEdit" title="Cancel"></i>
                  </template>
                </td>
                <!-- Delete -->
                <td class="text-center">
                  <i class="fa fa-trash edit-delete" v-if="protocol.status !== 'Generated'" style="color: #a13b7c"
                    @click="deleteRow(activity.id)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="row mx-0" v-if="activities.length > 0">
          <div class="col-lg-12 mx-0 px-0">
            <div class="dataTables_paginate paging_simple_numbers pagination float-right">
              <div class="col-lg-12 d-flex justify-content-lg-end px-0">
                <v-pagination v-model="currentPage" :pages="totalPages" :range-size="0" active-color="#618bd7"
                  @update:modelValue="loadPage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.action-icon {
  cursor: pointer;
  font-size: 18px;
  margin: 0 5px;
}

.action-icon:hover {
  opacity: 0.8;
}

.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}

.wrap-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 200px;
  overflow: hidden;
}

textarea.form-control {
  resize: vertical;
  max-height: 150px;
}

.sticky-column {
  position: sticky;
  right: 0;
  background-color: #fff;
  z-index: 10;
  border-left: 1px solid #dee2e6;
}

.badge-success {
  background-color: #28a745;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
}

.badge-secondary {
  background-color: #6c757d;
  color: #fff;
  padding: 3px 8px;
  border-radius: 4px;
}
.position-relative .tool-tip {  
  right: 20px;
  top: 0px;
}

/* NEW: more/less toggle link for long Description text */
.more-less-link {
  color: #618bd7;
  font-weight: 600;
  margin-left: 4px;
  white-space: nowrap;
}

.more-less-link:hover {
  text-decoration: underline;
}
</style>

<script src="./Activitymanagement.js"></script>